/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState } from 'react';
import { CorporateClubListData, IStatesContext, IAppProvider } from './types/corpclub-type';

export const BeneficiariesDataContext = createContext<IStatesContext | null>(null);

export const BeneficiariesDataContextStorage = ({ children }: IAppProvider): JSX.Element => {
  const [beneficiariesData, setBeneficiariesData] = useState<CorporateClubListData>();
  const env = window.smlsEnv === 'hml5' ? 'uat5' : window.smlsEnv;

  const defaultValues = {
    states: {
      beneficiariesData: {
        getter: beneficiariesData,
        setter: setBeneficiariesData,
      },
      env: {
        getter: env,
      },
    },
  } as any;

  const states = { ...defaultValues.states };
  const contextProps = { value: { ...defaultValues, states }, children } as any;
  return React.createElement(BeneficiariesDataContext.Provider, contextProps);
};

export const useBeneficiariesDataContextStorage = (): IStatesContext | null => {
  const context = React.useContext(BeneficiariesDataContext);
  return context;
};

export default BeneficiariesDataContextStorage;
